import {ReportComponent} from 'appEntries/panel/classes/report-component';
import {
    ApiError,
    ApiResponse,
    ClientFeedSubscriptionInterface,
    ClientFeedSubscriptionModel,
    HttpStatusCodesEnum,
    ServerResponseData,
    SesService,
    UserAccountSubscriptionFilterModel,
    UserAccountSubscriptionResponseInterface
} from '@spa/api';
import {AfterViewInit, Component, Injector, OnDestroy, OnInit} from '@angular/core';
import {LayoutConfigInterface} from 'appEntries/panel/components';
import {ColumnSizesEnum, PermissionRuleCheckStrategiesEnum, PermissionsEnum} from 'appShared/enums';
import {PanelClientUsersEditResolverDataInterface} from 'appEntries/panel/interfaces';
import {PermissionRuleInterface} from 'appShared/interfaces';
import {FilterModel} from '@spa/api/lib/common';
import {ReportTableDataRow} from 'appShared/components';
import {Observable, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {EventsService} from 'appEntries/panel/services';
import {AlertsService, CacheCollectionService} from 'appShared/services';
import {MarketDataFeedSubscriptionMessages} from 'appAssets/messages';
import {PermissionRulesTrait} from 'appEntries/panel/traits';

@Component({
    template: ''
})
export abstract class BaseMarketDataUserDetailReportComponent
    extends ReportComponent<ClientFeedSubscriptionInterface, ClientFeedSubscriptionModel>
    implements OnInit, OnDestroy, AfterViewInit {
    protected activatedRoute: ActivatedRoute;
    protected subscriptions: Subscription[];
    protected sesService: SesService;
    protected alertsService: AlertsService;

    public viewMarkupPermission: PermissionRuleInterface;
    public viewPricePermission: PermissionRuleInterface;
    public viewUserPermission: PermissionRuleInterface;
    public assingFeedToUserPermission: PermissionRuleInterface;
    public editAssignedFeedsPermission: PermissionRuleInterface;
    public setMarkupPermission: PermissionRuleInterface;
    public setPricePermission: PermissionRuleInterface;
    public viewUserSettingsPermission: PermissionRuleInterface;
    public subscriptionModels: ClientFeedSubscriptionModel[];

    protected constructor(
        injector: Injector,
    ) {
        super(
            injector.get<Router>(Router),
            injector.get<EventsService>(EventsService),
            injector.get<CacheCollectionService>(CacheCollectionService)
        );

        this.activatedRoute = injector.get<ActivatedRoute>(ActivatedRoute);
        this.sesService = injector.get<SesService>(SesService);
        this.alertsService = injector.get<AlertsService>(AlertsService);

        this.subscriptions = [];
        this.subscriptionModels = [];

        this.viewMarkupPermission = PermissionRulesTrait.getViewFeedMarkupPermissionRule();

        this.viewUserPermission = {
            permissions: PermissionRulesTrait.getUserViewPermissionRule().permissions,
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
        this.viewPricePermission = PermissionRulesTrait.getViewSubscriptionPricePermissionRule();
        this.assingFeedToUserPermission = PermissionRulesTrait.getAssignFeedsToUsersPermissionRule();
        this.editAssignedFeedsPermission = PermissionRulesTrait.getEditAssignedFeedsToUsersPermissionRule();
        this.setMarkupPermission = PermissionRulesTrait.getSetFeedMarkupPermissionRule();
        this.setPricePermission = PermissionRulesTrait.getSetSubscriptionPricePermissionRule();
        this.viewUserSettingsPermission = PermissionRulesTrait.getSesUserSettingsViewPermissionRule();
    }

    protected abstract prepareSubscriptions(
        subscriptionResponseData: UserAccountSubscriptionResponseInterface,
        accountAndSubscriptions: ClientFeedSubscriptionModel[]
    ) ;

    protected prepareUserSubscriptions(
        subsFilterModel: UserAccountSubscriptionFilterModel,
        accountAndSubscriptions: ClientFeedSubscriptionModel[]
    ) {
        const subscription = this.sesService.listUserAccountSubscriptions(subsFilterModel)
        .subscribe((subscriptionResponse: ApiResponse<ApiError[] | UserAccountSubscriptionResponseInterface>) => {

            if (subscriptionResponse.status !== HttpStatusCodesEnum.Ok) {
                (subscriptionResponse.data as ApiError[]).forEach((error: ApiError) => {
                    this.alertsService.addAlert(this.getErrorMessage(subscriptionResponse, error));
                });

                return;
            }

            const subscriptionResponseData = subscriptionResponse.data as UserAccountSubscriptionResponseInterface;

            if (subscriptionResponseData.content?.length === 0) {
                this.subscriptionModels = accountAndSubscriptions;

                return;
            }

            this.prepareSubscriptions(subscriptionResponseData, accountAndSubscriptions);
            this.subscriptionModels = accountAndSubscriptions;
        });

        this.subscriptions.push(subscription);
    }

    getErrorMessage(response: ApiResponse<ApiError[] | UserAccountSubscriptionResponseInterface>, error: ApiError): string {
        if (Array.isArray(response.messages) && response.messages[0]) {
            return response.messages[0];
        }

        return MarketDataFeedSubscriptionMessages.UnknownError.message;
    }

    getInitialFilterModel(itemsPerPage?: number): FilterModel {
        return null;
    }

    getFilterModel(data: { [p: string]: string | number | boolean; }): FilterModel {
        return null;
    }

    mapFilterResults(results: ClientFeedSubscriptionInterface[]): ClientFeedSubscriptionModel[] {
        return null;
    }

    createDataSource(data: ClientFeedSubscriptionModel[]): ReportTableDataRow[] {
        return null;
    }

    getReportHandler(filter: FilterModel): Observable<ApiResponse<ClientFeedSubscriptionInterface[] | ApiError[]>> {
        return null;
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        super.afterViewInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }

    getTitle(): string {
        return '';
    }

    getText(): string {
        return '';
    }

    getLayoutConfig(): LayoutConfigInterface {
        return {
            mainColumnSize: ColumnSizesEnum.Col12,
            subColumnSize: null
        };
    }

    validateInitialData(response: ServerResponseData<PanelClientUsersEditResolverDataInterface>): void {
    }
}
